import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap, catchError } from 'rxjs/operators';
import { ChecklistRepository } from '../../../infrastructure/repositories/checklist.repository';
import { ChecklistListState } from '../../states/checklist-list.state';
import { GetAllChecklistsResult } from './get-all-checklists.result';

@Injectable({ providedIn: 'root' })
export class GetAllChecklistsUseCase {
  private readonly _repository = inject(ChecklistRepository);
  private readonly _state = inject(ChecklistListState);

  public execute(): Observable<GetAllChecklistsResult> {
    this._state.setLoading(true);
    this._state.clearError();

    return this._repository.getAllChecklists().pipe(
      tap((result) => {
        this._state.setChecklists(result.data);
        this._state.setChecklistsCount(result.totalElements);
        this._state.setLoading(false);
      }),
      map((result) => ({ checklists: result.data })),
      catchError((error) => {
        this._state.setLoading(false);
        this._state.setError(error?.error?.message || error?.message || 'Failed to load checklists');
        throw error;
      }),
    );
  }
}
